import type { Slice } from "@reduxjs/toolkit";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { MeshKeyRotationEvent } from "@somewear/api";

import { WorkspaceState } from "../workspace.state";
import { workspaceMeshKeyRotationsActions } from "./workspaceMeshKeyRotations.actions";

export interface MeshKeyRotationEventState extends MeshKeyRotationEvent.AsObject {
	workspaceId: string;
}

const adapter = createEntityAdapter<MeshKeyRotationEventState, string>({
	selectId: (rotation) => rotation.id,
});

export const { selectAll: selectAllMeshKeyRotations } = adapter.getSelectors(
	(state: WorkspaceState) => state.workspaceMeshKeyRotations,
);

export const workspaceMeshKeyRotationsSlice: Slice = createSlice({
	name: "workspaceMeshKeyRotations",
	initialState: adapter.getInitialState({
		isScheduleLoading: false,
	}),
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(
			workspaceMeshKeyRotationsActions.getMeshTrafficKeyHistory.fulfilled,
			(state, action) => {
				const events = action.payload.data.eventsList.map((event) => ({
					...event,
					workspaceId: action.payload.data.workspaceId,
				}));

				adapter.upsertMany(state, events);
			},
		);
		builder.addCase(
			workspaceMeshKeyRotationsActions.scheduleMeshTrafficKeyRotation.pending,
			(state) => {
				state.isScheduleLoading = true;
			},
		);
		builder.addCase(
			workspaceMeshKeyRotationsActions.scheduleMeshTrafficKeyRotation.fulfilled,
			(state) => {
				state.isScheduleLoading = false;
			},
		);
		builder.addCase(
			workspaceMeshKeyRotationsActions.scheduleMeshTrafficKeyRotation.rejected,
			(state) => {
				state.isScheduleLoading = false;
			},
		);
		builder.addCase(
			workspaceMeshKeyRotationsActions.skipScheduledMeshTrafficKeyRotation.pending,
			(state) => {
				state.isScheduleLoading = true;
			},
		);
		builder.addCase(
			workspaceMeshKeyRotationsActions.skipScheduledMeshTrafficKeyRotation.fulfilled,
			(state) => {
				state.isScheduleLoading = false;
			},
		);
		builder.addCase(
			workspaceMeshKeyRotationsActions.skipScheduledMeshTrafficKeyRotation.rejected,
			(state) => {
				state.isScheduleLoading = false;
			},
		);
	},
});
